import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InputSearch } from 'ui/inputs';
import { pxToRem } from 'utils/convert';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { useQueryContext } from '../context';

const DEBOUNCE_TIMEOUT_MS = 500;

const SearchBar = styled(InputSearch)`
  width: ${pxToRem(450)};
`;

const TEXT = {
  searchPlaceholder: 'Search views',
};

export const SavedViewsSearchBar = () => {
  // Debounced input values
  const { searchTerm: debouncedInputValue, setSearchTerm: setDebouncedInputValue } =
    useQueryContext();

  // Non-debounced input values
  const [inputValue, setInputValue] = useState(debouncedInputValue);

  // Updates to debouncedInputValue will trigger view filtering
  const resetSearchDebouncer = useDebouncedEffect(
    () => setDebouncedInputValue(inputValue),
    [inputValue],
    {
      skipEffectOnMount: true,
      debounceTimeout: DEBOUNCE_TIMEOUT_MS,
    },
  );

  useEffect(() => {
    resetSearchDebouncer();
    setInputValue(debouncedInputValue);
  }, [debouncedInputValue]);

  return (
    <SearchBar
      id="views-index-search-bar"
      onChange={setInputValue}
      placeholder={TEXT.searchPlaceholder}
      value={inputValue}
    />
  );
};
